module.exports = __webpack_public_path__ + "static/media/banner-External_Resources.f3556621.png";